import type { InputRef, TabsProps } from 'antd';
import { userApis } from '@/configs/apis/user';
import { useChatContext } from '@/contexts/chat/context';
import type { User } from '@/configs/apis/user';
import styles from './index.module.scss';
import SearchInputIcon from './images/search_input.svg?react';
import SearchIcon from './images/search.svg?react';
import MoreItemIcon from './images/more-item.svg?react';
import Contacts from './components/contacts';
import Empty from './components/empty';
// import SearchHistory from './components/search-history';

const NavSearch = ({ collapse }: { collapse: boolean }) => {
  const { createChat, activeChat, chatsState } = useChatContext();
  const [users, setUsers] = useState<User[]>([]);
  const [open, setOpen] = useState(false);
  const inputRef = useRef<InputRef>(null);
  const abortControllerRef = useRef<AbortController>();

  const { run: handleSearch } = useDebounceFn(
    async (e: React.ChangeEvent<HTMLInputElement>) => {
      abortControllerRef.current?.abort();

      const p = userApis.search(e.target.value);

      abortControllerRef.current = p.abortController;

      setUsers(await p);
    },
    {
      wait: 300,
    }
  );

  const onTabChange = (key: string) => {
    console.log(key);
  };

  const TabItems: TabsProps['items'] = [
    {
      key: 'TopResults',
      label: 'Top Results',
      children: (
        <div className={cls(styles.content, 'scrollbar_hover')}>
          <div>
            <Empty />
          </div>
        </div>
      ),
    },
    {
      key: 'Contacts',
      label: 'Contacts',
      children: (
        <div className={cls(styles.content, 'scrollbar_hover')}>
          <Contacts
            users={users}
            setOpen={setOpen}
            activeChat={activeChat}
            createChat={createChat}
            chats={chatsState.chats}
          />
        </div>
      ),
    },
    {
      key: 'Groups',
      label: 'Groups',
      children: (
        <div className={cls(styles.content, 'scrollbar_hover')}>
          <div>
            <Empty />
          </div>
        </div>
      ),
    },
    {
      key: 'Communities',
      label: 'Communities',
      children: (
        <div className={cls(styles.content, 'scrollbar_hover')}>
          <div>
            <Empty />
          </div>
        </div>
      ),
    },
    {
      key: 'Dapps',
      label: 'Dapps',
      children: (
        <div className={cls(styles.content, 'scrollbar_hover')}>
          <div>
            <Empty />
          </div>
        </div>
      ),
    },
    {
      key: 'Bots',
      label: 'Bots',
      children: (
        <div className={cls(styles.content, 'scrollbar_hover')}>
          <div>
            <Empty />
          </div>
        </div>
      ),
    },
    {
      key: 'Global',
      label: 'Global',
      children: (
        <div className={cls(styles.content, 'scrollbar_hover')}>
          <div>
            <Empty />
          </div>
        </div>
      ),
    },
    {
      key: 'Media',
      label: 'Media',
      children: (
        <div className={cls(styles.content, 'scrollbar_hover')}>
          <div>
            <Empty />
          </div>
        </div>
      ),
    },
  ];

  const handleOpen = () => {
    setOpen(true);
  };

  useEffect(() => {
    let timer: number;
    if (open) {
      timer = window.setTimeout(() => {
        inputRef.current?.focus({
          cursor: 'end',
        });
      }, 350);
    } else {
      setUsers([]);
    }
    return () => {
      clearTimeout(timer);
    };
  }, [open]);

  return (
    <div className={styles.searchInput}>
      {collapse ? (
        <div className={styles.search} onClick={handleOpen}>
          <SearchIcon></SearchIcon>
        </div>
      ) : (
        <div className={styles.input} onClick={handleOpen}>
          <div>Search...</div>
          <SearchInputIcon />
        </div>
      )}

      <Modal
        destroyOnHidden
        centered
        open={open}
        closeIcon={null}
        footer={null}
        onCancel={() => setOpen(false)}
        styles={{
          content: {
            padding: '16px',
          },
        }}
      >
        <div className={styles.modalWrapper}>
          <div className={styles.searchIpt}>
            <Input
              ref={inputRef}
              variant="filled"
              onChange={handleSearch}
              placeholder="Search..."
            />
            <div className={styles.cancel} onClick={() => setOpen(false)}>
              Cancel
            </div>
          </div>
          <Tabs
            className={styles.tabs}
            defaultActiveKey="Contacts"
            items={TabItems}
            renderTabBar={(props, DefaultTabBar) => (
              <>
                <DefaultTabBar {...props} />
                {/* <SearchHistory /> */}
              </>
            )}
            onChange={onTabChange}
            tabBarStyle={{ marginBottom: 0 }}
            indicator={{ size: () => 12 }}
            tabBarExtraContent={<MoreItemIcon />}
          />
        </div>
      </Modal>
    </div>
  );
};

export default NavSearch;
